function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M177.2 226.9v-35.5h92.1V71h-36.6l-28.1 28.3H241v63.8h-99.7l-28.1 28.4h35.6v63.8h134.7v-28.4zM73.5 163.1L49 99.3h115.4L192.5 71H7.7l10.9 28.3H0v63.8h43.1L54 191.5h19l28.1-28.4zM9.682 264.005L264.201 9.271l10.257 10.248L19.94 274.254z"
})));